import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesRefunds } from "../../constants";

export const requestConfirmRefund = async (refundId: string): Promise<void> => {
  return await instance.post(
    buildUrl(ApiRoutesRefunds.Refunds, refundId, ApiRoutesRefunds.Confirm)
  );
};
